import { render, staticRenderFns } from "./NeckDataItem.vue?vue&type=template&id=3dbb89cc&scoped=true&"
import script from "./NeckDataItem.vue?vue&type=script&lang=js&"
export * from "./NeckDataItem.vue?vue&type=script&lang=js&"
import style0 from "./NeckDataItem.vue?vue&type=style&index=0&id=3dbb89cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb89cc",
  null
  
)

export default component.exports